import { connect } from 'react-redux';
import CallingWrapper from './voipPopUp/CallingWrapper';
import ActiveCallPopUp from './voipPopUp/popUp/ActiveCallPopUp';

const Calling = (props) => {
  const { call_pop_up_status, active_call_popup, isCallActive } = props

  return (
    <>
      {call_pop_up_status && <CallingWrapper />}
      {(active_call_popup && isCallActive) && <ActiveCallPopUp />}
    </>
  )
}

const mapStateToProps = state => {
  const { voip } = state;
  return {
    call_pop_up_status: voip?.call_pop_up_status,
    active_call_popup: voip?.active_call_popup,
    isCallActive: voip?.calling_info.isCallActive,
  }
}

export default connect(mapStateToProps)(Calling);